module.exports = __webpack_public_path__ + "img/fashion_72.9bdefc49.jpg";